import { render, staticRenderFns } from "./Typography.vue?vue&type=template&id=4f4fcccc&scoped=true&"
import script from "./Typography.vue?vue&type=script&lang=ts&"
export * from "./Typography.vue?vue&type=script&lang=ts&"
import style0 from "./Typography.vue?vue&type=style&index=0&id=4f4fcccc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f4fcccc",
  null
  
)

export default component.exports